import { styled, Box, Typography, Button, Container } from "@mui/material"

export const Root = styled(Box)(({ theme }) => ({
  "& .MuiDialog-paper": {
    width: "100%",
    maxWidth: "500px",
    padding: "1rem 0",
  },
}))

export const StyledContainer = styled(Container)(({ theme }) => ({
  width: "100%",
  maxWidth: "650px",
  position: "relative",
  padding: "20px 20px 10px",
}))

export const Title = styled(Typography)(({ theme }) => ({
  textAlign: "left",
  color: "#FF8C42",
  fontSize: "1.3rem",
  marginBottom: "1.4rem",
}))

export const CloseBtn = styled(Button)(({ theme }) => ({
  background: "#f1f1f5",
  position: "absolute",
  top: 10,
  right: 10,
  width: 30,
  height: 30,
}))

export const BtnSubmit = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  marginTop: "2rem",
}))
